@if (contractorComments.length > 0 || agencyNotes.length > 0 || (isQbat && notesFromFSAgency?.length > 0)) {
  <div class="m-3">
    <div id="qbat-notes-summary">
      <div id="qbat-contractor-comments">
        @if (contractorComments.length > 0) {
          <div class="heading-box flex justify-between mt-3">
            <h3 class="font-medium">All Comments to Contractors</h3>
            <small>From QualityBidders</small>
          </div>
          <ul>
            <!-- Tracking by Step and Section - This is hopefully the most unique identifier -->
            @for (item of contractorComments; track item.step + ' ' + item.section) {
              <li>
                @if (!item.isAgency && item.step === 0) {
                  <p>General Comments:</p>
                }
                @if (!item.isAgency && item.step > 0) {
                  <p>Step {{ item.step }}: {{ item.label }}</p>
                }
                @if (item.isAgency) {
                  <p>Agency: {{ item.label }}</p>
                }
                <p class="whitespace-break-spaces">"{{ item.contractorComments }}"</p>
              </li>
            }
          </ul>
        }
      </div>
      <div id="qbat-agency-notes">
        @if (agencyNotes.length > 0) {
          <div class="heading-box flex justify-between mt-3">
            <h3 class="font-medium">All Notes to Agencies</h3>
            <small>From QualityBidders</small>
          </div>
          <ul>
            <!-- Tracking by Step and Section - This is hopefully the most unique identifier -->
            @for (item of agencyNotes; track item.step + ' ' + item.section) {
              <li>
                @if (!item.isAgency && item.step === 0) {
                  <p>General Notes:</p>
                }
                @if (!item.isAgency && item.step > 0) {
                  <p>Step {{ item.step }}: {{ item.label }}</p>
                }
                @if (item.isAgency) {
                  <p>Agency: {{ item.label }}</p>
                }
                <p class="whitespace-break-spaces">"{{ item.agencyNotes }}"</p>
              </li>
            }
          </ul>
        }
      </div>
    </div>
    @if (!isQbat && notesFromFSAgency?.length > 0) {
      <div id="agency-user-notes-summary">
        <div class="heading-box flex justify-between mt-3">
          <h3 class="font-medium">Agency Notes</h3>
          <small>From Agency Users</small>
        </div>
        <p>"{{ notesFromFSAgency }}"</p>
      </div>
    }
  </div>
}
